import { Component, OnInit, ViewChild, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { FormGroup, FormControl } from '@angular/forms';
import { InventarioCapaService } from 'src/app/services/inventario-capa.service';
import { MatDialog } from '@angular/material/dialog';
import { Router, ActivatedRoute } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { take } from 'rxjs/operators';
import { HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { ModalConfirmacaoComponent } from 'src/app/@shared/components';
import { ContagemInventarioComponent } from '../contagem-inventario/contagem-inventario.component';
import { ModalResumoQuantidadeStatusComponent } from './modal-resumo-quantidade-status/modal-resumo-quantidade-status.component';

@Component({
  selector: 'app-inventario-capa-contagem',
  templateUrl: './inventario-capa-contagem.component.html',
  styleUrls: ['./inventario-capa-contagem.component.scss']
})
export class InventarioCapaContagemComponent implements OnInit, AfterViewInit {

  public modalItem: any;
  public isLoading = false;
  public inventarioId;
  public inventario = {} as any;
  public displayedColumns: string[] = [
    'actions',
    'numeroContagem',
    'dtCriacao',
    'criadoPor',
    'dtEncerramento',
    'encerradoPor',
    'qtdPedidos',
    'qtdVolume',
    'status',
  ];

  public status: Array<any>;
  public paging = { index: 0, size: 10, length: 0 };
  public permissions = { canCreate: false, canOpen: false };
  public inventarioContagemCapaCollection: MatTableDataSource<any> = new MatTableDataSource<any>();
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;

  public inventarioForm: FormGroup = new FormGroup({
    numero: new FormControl({ value: "", disabled: true }),
    agente: new FormControl({ value: "", disabled: true }),
    status: new FormControl({ value: "", disabled: true }),
    dtCriacao: new FormControl({ value: "", disabled: true }),
    criadoPor: new FormControl({ value: "", disabled: true }),
    dtAutInicioGestor: new FormControl({ value: "", disabled: true }),
    usuarioGestorAutInicio: new FormControl({ value: "", disabled: true }),
    dtAutFinGestor: new FormControl({ value: "", disabled: true }),
    usuarioGestorAutFin: new FormControl({ value: "", disabled: true }),
  });

  constructor(
    private inventarioCapaService: InventarioCapaService,
    public dialog: MatDialog,
    public router: Router,
    private route: ActivatedRoute,
    public snackBar: MatSnackBar,
    private cdr: ChangeDetectorRef
  ) {
  }

  ngOnInit() { }

  async ngAfterViewInit() {
    let encodedParams = this.route.snapshot.paramMap.get('params');
    let params = JSON.parse(encodedParams ? atob(decodeURIComponent(encodedParams)) : '{}');
    this.inventarioId = params.inventarioId;
    this.cdr.detectChanges();
    this.search();
  }

  public search() {
    this.isLoading = true;
    this.inventarioContagemCapaCollection.data = null;
    this.loadInventarioContagens();
    this.loadInventario();
  }

  private loadInventarioContagens() {
    this.inventarioCapaService.getAllInventarioContagens({
      inventarioId: this.inventarioId
    })
      .pipe(take(1))
      .subscribe((response: HttpResponse<any>) => {
        this.inventarioContagemCapaCollection.data = response.body;
        if (response.body.length > 0) {
          this.paging.length = response.body[0].totalCount;
        }
        this.isLoading = false;
      }, (err: HttpErrorResponse) => {
        console.error(err);
        this.isLoading = false;
        this.openSnackBar('Erro ao carregar listagem, entre em contato com o suporte : ' + err.error.Protocolo ?? err.error.Message, 'OK', 10000, 'danger-snackbar');
      });
  }

  public efetuarContagem(inventarioContagemId) {
    const params = encodeURIComponent(btoa(JSON.stringify({ inventarioContagemId })));
    this.router.navigate(['/inventario/contagem-itens', params]);
  }

  private loadInventario() {
    this.inventarioCapaService.getAll({
      inventarioId: this.inventarioId
    })
      .pipe(take(1))
      .subscribe((response: HttpResponse<any>) => {
        this.inventario = response.body[0];
        this.loadFields();
        this.isLoading = false;
      }, (err: HttpErrorResponse) => {
        console.error(err);
        this.isLoading = false;
        this.openSnackBar('Erro ao carregar listagem, entre em contato com o suporte : ' + err.error.Protocolo ?? err.error.Message, 'OK', 10000, 'danger-snackbar');
      });
  }

  private loadFields() {
    this.inventarioForm.get('numero').setValue(this.inventario.numero);
    this.inventarioForm.get('agente').setValue(this.inventario.agente);
    this.inventarioForm.get('status').setValue(this.inventario.status);
    this.inventarioForm.get('dtCriacao').setValue(this.inventario.dtCriacao);
    this.inventarioForm.get('criadoPor').setValue(this.inventario.criadoPor);
    this.inventarioForm.get('dtAutInicioGestor').setValue(this.inventario.dtAutInicioGestor);
    this.inventarioForm.get('usuarioGestorAutInicio').setValue(this.inventario.usuarioGestorAutInicio);
    this.inventarioForm.get('dtAutFinGestor').setValue(this.inventario.dtAutFinGestor);
    this.inventarioForm.get('usuarioGestorAutFin').setValue(this.inventario.usuarioGestorAutFin);
  }

  public voltar() {
    this.router.navigate(['/gestao/inventario/gerar-inventario']);
  }


  public openModalExibirContagens(inventarioContagem): void {

    const modalReference = this.dialog.open(ContagemInventarioComponent, {
      disableClose: true,
      width: '90vw',
      height: '95vh',
      data: {
        item: {
          inventarioId: inventarioContagem.inventarioId,
          inventarioContagemId: inventarioContagem.inventarioContagemId,
          agente: inventarioContagem.agente,
          codIATA: inventarioContagem.iata,
          numeroContagem: inventarioContagem.numeroContagem,
          dataCriacaoContagem: inventarioContagem.dtCriacao,
          criadoPorContagem: inventarioContagem.criadoPor
        }
      }
    });

    modalReference.afterClosed().pipe(take(1)).subscribe(() => { });
  }

  // public openModalExibirResumoPorStatus(inventarioContagem): void {

  //   const modalReference = this.dialog.open(ModalResumoQuantidadeStatusComponent, {
  //     disableClose: true,
  //     width: '80vw',
  //     height: '80vh',
  //     data: {
  //       item: {
  //         inventarioId: inventarioContagem.inventarioId,
  //         inventarioContagemId: inventarioContagem.inventarioContagemId,
  //         numeroContagem: inventarioContagem.numeroContagem,
  //       }
  //     }
  //   });

  //   modalReference.afterClosed().pipe(take(1)).subscribe(() => { });
  // }

  public createInventarioContagem() {

    const dialogRef = this.dialog.open(ModalConfirmacaoComponent, {
      width: '540px',
      data: {
        textoCancelar: "Não",
        textoOk: "Sim",
        texto: "Tem certeza que deseja criar uma nova contagem?",
      },
    });

    dialogRef.afterClosed().pipe(take(1)).subscribe(
      async response => {
        if (response === 1) {

          this.inventarioCapaService.createInventarioContagem({ inventarioId: this.inventarioId })
            .pipe(take(1))
            .subscribe(
              () => {
                this.isLoading = false;
                this.loadInventarioContagens();
                this.openSnackBar('Contagem criada com sucesso!', 'OK', 5000);
              },
              (response) => {
                this.isLoading = false;
                if (response.status === 409) {
                  this.openSnackBar(response.error.message, 'OK', 5000, 'warning-snackbar');
                }

              });
        }
      });
  }

  public existsContagemAberta() {
    return this.inventarioContagemCapaCollection.data?.filter(object => object.inventarioContagemStatusId === 1).length > 0;
  }

  public encerrarContagem(inventarioContagemId) {
    const dialogRef = this.dialog.open(ModalConfirmacaoComponent, {
      width: '540px',
      data: {
        textoCancelar: "Não",
        textoOk: "Sim",
        texto: "Tem certeza que deseja encerrar esta contagem?",
      },
    });

    dialogRef.afterClosed().pipe(take(1)).subscribe(
      async response => {
        if (response === 1) {
          this.inventarioCapaService.encerrarInventarioContagem({ inventarioContagemId, inventarioId: this.inventarioId })
            .pipe(take(1))
            .subscribe(
              () => {
                this.isLoading = false;
                this.openSnackBar('Contagem encerrada com sucesso!', 'OK', 5000);
              },
              (response) => {
                this.isLoading = false;
                if (response.status === 409) {
                  this.openSnackBar(response.error.message, 'OK', 5000, 'warning-snackbar');
                }

              });
        }
      });
  }

  public cancelarContagem(inventarioContagemId) {
    const dialogRef = this.dialog.open(ModalConfirmacaoComponent, {
      width: '540px',
      data: {
        textoCancelar: "Não",
        textoOk: "Sim",
        texto: "Tem certeza que deseja cancelar esta contagem?",
      },
    });

    dialogRef.afterClosed().pipe(take(1)).subscribe(
      async response => {
        if (response === 1) {
          this.inventarioCapaService.cancelarInventarioContagem({ inventarioContagemId, inventarioId: this.inventarioId })
            .pipe(take(1))
            .subscribe(
              () => {
                this.isLoading = false;
                this.openSnackBar('Contagem cancelada com sucesso!', 'OK', 5000);
              },
              (response) => {
                this.isLoading = false;
                if (response.status === 409) {
                  this.openSnackBar(response.error.message, 'OK', 5000, 'warning-snackbar');
                }

              });
        }
      });
  }

  private openSnackBar(message: string, action: string, duration: number, panelClass?: string): any {
    this.snackBar.open(message, action, { duration, panelClass });
  }

}
